// Internet Explorer — the homepage, and since 2026-09-08 the Time Machine: the address bar browses,
// but through the Wayback Machine, so every site loads the way it looked in the year you pick.
// Community ask: "virtual browser… the websites shows old not new like now". Nothing is proxied by us.
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { WindowDropDowns, InternetHome } from 'components';
import dropDownData from './dropDownData';
import { FAVORITES, YEARS, DEFAULT_YEAR, normalizeUrl, isHome, waybackUrl, wayback } from './timeMachine';
import { InternalPage, INTERNAL_HOSTS, resolveInternal } from './internalWeb';
import ie from 'assets/windowsIcons/ie-paper.png';
import printer from 'assets/windowsIcons/17(32x32).png';
import goIcon from 'assets/windowsIcons/290.png';
import links from 'assets/windowsIcons/links.png';
import search from 'assets/windowsIcons/299(32x32).png';
import favorite from 'assets/windowsIcons/744(32x32).png';
import back from 'assets/windowsIcons/back.png';
import earth from 'assets/windowsIcons/earth.png';
import edit from 'assets/windowsIcons/edit.png';
import forward from 'assets/windowsIcons/forward.png';
import history from 'assets/windowsIcons/history.png';
import home from 'assets/windowsIcons/home.png';
import mail from 'assets/windowsIcons/mail.png';
import msn from 'assets/windowsIcons/msn.png';
import refresh from 'assets/windowsIcons/refresh.png';
import stop from 'assets/windowsIcons/stop.png';
import windows from 'assets/windowsIcons/windows.png';
import dropdown from 'assets/windowsIcons/dropdown.png';

const HOME_URL = 'https://internetcoin.vip/';

function InternetExplorer({ onClose, startUrl, startYear }) {
  const initialInternal = startUrl ? resolveInternal(normalizeUrl(startUrl)) : null;
  const initialWeb = !!startUrl && !initialInternal;
  const [route, setRoute] = useState(initialInternal ? 'internal' : initialWeb ? 'web' : 'main');
  const [page, setPage] = useState(initialInternal);
  const [url, setUrl] = useState(startUrl ? normalizeUrl(startUrl) : '');
  const [year, setYear] = useState(startYear || DEFAULT_YEAR);
  const [typed, setTyped] = useState(startUrl ? `http://${normalizeUrl(startUrl)}/` : HOME_URL);
  const [favOpen, setFavOpen] = useState(initialWeb && window.innerWidth >= 800);
  const [loading, setLoading] = useState(initialWeb);
  const [nonce, setNonce] = useState(0);
  const [hist, setHist] = useState([]); // sites visited this window, newest last
  const inputRef = useRef(null);

  useEffect(() => {
    if (route !== 'web') return undefined;
    const t = setTimeout(() => setLoading(false), 12000); // wayback can be slow; never hang the status bar
    return () => clearTimeout(t);
  }, [route, url, year, nonce]);

  function goHome() {
    setRoute('main');
    setUrl('');
    setTyped(HOME_URL);
    setLoading(false);
  }
  function go(input, y) {
    if (isHome(input)) return goHome();
    const n = normalizeUrl(input);
    const internal = resolveInternal(n);
    if (internal) {
      // the internal web: pages that only exist inside this IE (webring / under construction / the door)
      setPage(internal);
      setUrl(INTERNAL_HOSTS[internal]);
      setTyped(`http://${INTERNAL_HOSTS[internal]}/`);
      setRoute('internal');
      setLoading(false);
      if (inputRef.current) inputRef.current.blur();
      return;
    }
    if (y) setYear(y);
    setUrl(n);
    setTyped(`http://${n}${n.includes('/') ? '' : '/'}`);
    setRoute('web');
    setLoading(true);
    setNonce(x => x + 1);
    setHist(h => [...h.filter(x => x !== n), n].slice(-12));
    if (inputRef.current) inputRef.current.blur();
  }
  function onSubmit(e) {
    e.preventDefault();
    go(typed);
  }
  function onYear(e) {
    const y = Number(e.target.value);
    setYear(y);
    if (route === 'web') {
      setLoading(true);
      setNonce(x => x + 1);
    }
  }
  function reload() {
    if (route !== 'web') return;
    setLoading(true);
    setNonce(x => x + 1);
  }
  function openMessenger() {
    window.dispatchEvent(new CustomEvent('ic:open', { detail: 'Windows Messenger' }));
  }
  function onClickOptionItem(item) {
    switch (item) {
      case 'Close':
        onClose();
        break;
      case 'Home Page':
      case 'Back':
        goHome();
        break;
      case 'Refresh':
        reload();
        break;
      case 'Windows Messenger':
        openMessenger();
        break;
      default:
    }
  }

  const frameSrc = route === 'web' ? waybackUrl(url, year) : null;
  return (
    <Div>
      <section className="ie__toolbar">
        <div className="ie__options">
          <WindowDropDowns items={dropDownData} onClickItem={onClickOptionItem} height={21} />
        </div>
        <img className="ie__windows-logo" src={windows} alt="windows" />
      </section>
      <section className="ie__function_bar">
        <div onClick={goHome} className={`ie__function_bar__button${route === 'main' ? '--disable' : ''}`}>
          <img className="ie__function_bar__icon" src={back} alt="" />
          <span className="ie__function_bar__text">Back</span>
          <div className="ie__function_bar__arrow" />
        </div>
        <div className="ie__function_bar__button--disable">
          <img className="ie__function_bar__icon" src={forward} alt="" />
          <div className="ie__function_bar__arrow" />
        </div>
        <div className="ie__function_bar__button" onClick={() => setLoading(false)}>
          <img className="ie__function_bar__icon--margin-1" src={stop} alt="" />
        </div>
        <div className="ie__function_bar__button" onClick={reload}>
          <img className="ie__function_bar__icon--margin-1" src={refresh} alt="" />
        </div>
        <div className="ie__function_bar__button" onClick={goHome}>
          <img className="ie__function_bar__icon--margin-1" src={home} alt="" />
        </div>
        <div className="ie__function_bar__separate" />
        <div className="ie__function_bar__button" onClick={() => inputRef.current && inputRef.current.select()}>
          <img className="ie__function_bar__icon--normalize " src={search} alt="" />
          <span className="ie__function_bar__text">Search</span>
        </div>
        <div className={`ie__function_bar__button${favOpen ? ' ie__function_bar__button--on' : ''}`} onClick={() => setFavOpen(f => !f)} title="Favorites — the Time Machine">
          <img className="ie__function_bar__icon--normalize" src={favorite} alt="" />
          <span className="ie__function_bar__text">Favorites</span>
        </div>
        <div className="ie__function_bar__button" onClick={() => setFavOpen(f => !f)} title="History">
          <img className="ie__function_bar__icon" src={history} alt="" />
        </div>
        <div className="ie__function_bar__separate" />
        <div className="ie__function_bar__button">
          <img className="ie__function_bar__icon--margin-1" src={mail} alt="" />
          <div className="ie__function_bar__arrow--margin-11" />
        </div>
        <div className="ie__function_bar__button">
          <img className="ie__function_bar__icon--margin12" src={printer} alt="" />
        </div>
        <div className="ie__function_bar__button--disable">
          <img className="ie__function_bar__icon" src={edit} alt="" />
        </div>
        <div className="ie__function_bar__button" onClick={openMessenger} title="Windows Messenger">
          <img className="ie__function_bar__icon--margin12" src={msn} alt="" />
        </div>
      </section>
      <section className="ie__address_bar">
        <div className="ie__address_bar__title">Address</div>
        <form className="ie__address_bar__content" onSubmit={onSubmit}>
          <img src={ie} alt="ie" className="ie__address_bar__content__img" />
          <input
            ref={inputRef}
            className="ie__address_bar__content__input"
            value={typed}
            onChange={e => setTyped(e.target.value)}
            onFocus={e => e.target.select()}
            spellCheck={false}
            autoComplete="off"
            aria-label="Address"
          />
          <img src={dropdown} alt="dropdown" className="ie__address_bar__content__img" onClick={() => setFavOpen(f => !f)} />
        </form>
        <div className="ie__address_bar__go" onClick={() => go(typed)}>
          <img className="ie__address_bar__go__img" src={goIcon} alt="go" />
          <span className="ie__address_bar__go__text">Go</span>
        </div>
        <div className="ie__address_bar__separate" />
        <label className="ie__address_bar__year" title="Time Machine: the year the page is served from">
          <span>Year</span>
          <select value={year} onChange={onYear}>
            {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </label>
        <div className="ie__address_bar__separate" />
        <div className="ie__address_bar__links" onClick={() => setFavOpen(f => !f)}>
          <span className="ie__address_bar__links__text">Links</span>
          <img className="ie__address_bar__links__img" src={links} alt="links" />
        </div>
      </section>
      <div className="ie__content">
        {favOpen && (
          <aside className="ie__favbar">
            <div className="ie__favbar__head">
              <span>Favorites</span>
              <em>time machine</em>
              <span className="ie__favbar__x" onClick={() => setFavOpen(false)}>×</span>
            </div>
            <div className="ie__favbar__hint">pick a site, pick a year. the Wayback Machine serves the page the way it looked back then — inside IE. links keep working. type any site in the address bar, too.</div>
            <div className="ie__favbar__list">
              <div className="ie__favbar__group">the old web</div>
              {FAVORITES.map(f => (
                <div
                  key={f.url}
                  className={`ie__fav${route === 'web' && url === normalizeUrl(f.url) ? ' ie__fav--on' : ''}`}
                  onClick={() => go(f.url, f.year || undefined)}
                  title={f.note}
                >
                  <img src={favorite} alt="" />
                  <span>{f.name}</span>
                  <em>{f.year || 'local'}</em>
                </div>
              ))}
              {hist.length > 0 && <div className="ie__favbar__group">history (this window)</div>}
              {[...hist].reverse().map(h => (
                <div key={h} className="ie__fav ie__fav--hist" onClick={() => go(h)}>
                  <img src={history} alt="" />
                  <span>{h}</span>
                </div>
              ))}
              <div className="ie__fav ie__fav--home" onClick={goHome}>
                <img src={ie} alt="" />
                <span>internetcoin.vip</span>
                <em>now</em>
              </div>
            </div>
          </aside>
        )}
        <div className={`ie__main${route === 'web' ? ' ie__main--web' : ''}`}>
          {route === 'main' ? (
            <div className="ie__content__inner">
              <InternetHome />
            </div>
          ) : route === 'internal' ? (
            <InternalPage page={page} goto={go} />
          ) : (
            <>
              {loading && (
                <div className="ie__connecting">
                  <img src={earth} alt="" />
                  <div>Opening page http://{url} as it looked in {year}…</div>
                  <small>served by the Wayback Machine (web.archive.org). old sites take a moment. some never left.</small>
                </div>
              )}
              <iframe
                key={`${url}|${year}|${nonce}`}
                className={`ie__frame${loading ? '' : ' ie__frame--on'}`}
                title={`${url} (${year})`}
                src={frameSrc}
                sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-pointer-lock"
                referrerPolicy="no-referrer"
                onLoad={() => setLoading(false)}
              />
            </>
          )}
        </div>
      </div>
      <footer className="ie__footer">
        <div className="ie__footer__status">
          <img className="ie__footer__status__img" src={ie} alt="" />
          <span className="ie__footer__status__text">
            {route === 'web' ? (loading ? `Opening page http://${url}...` : `Done · snapshot from ${year} · web.archive.org`) : route === 'internal' ? 'Done · internal web (this computer only)' : 'Done'}
          </span>
        </div>
        <div className="ie__footer__block" />
        <div className="ie__footer__block" />
        <div className="ie__footer__block" />
        <div className="ie__footer__block" />
        <div className="ie__footer__right" onClick={() => route === 'web' && window.open(wayback(url, year), '_blank', 'noopener')} title={route === 'web' ? 'open this snapshot in a new tab' : ''}>
          <img className="ie__footer__right__img" src={earth} alt="" />
          <span className="ie__footer__right__text">{route === 'web' ? `Internet · ${year}` : route === 'internal' ? 'Local intranet' : 'Internet'}</span>
          <div className="ie__footer__right__dots" />
        </div>
      </footer>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);

  .ie__toolbar {
    position: relative;
    display: flex;
    align-items: center;
    line-height: 100%;
    height: 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.7);
    flex-shrink: 0;
  }
  .ie__options {
    height: 23px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    border-right: 1px solid rgba(0, 0, 0, 0.15);
    padding-left: 2px;
    flex: 1;
  }
  .ie__windows-logo {
    height: 100%;
    border-left: 1px solid white;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .ie__function_bar {
    height: 36px;
    display: flex;
    align-items: center;
    font-size: 11px;
    padding: 1px 3px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
  }
  .ie__function_bar__button {
    display: flex;
    height: 100%;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0);
    border-radius: 3px;
    &:hover {
      border: 1px solid rgba(0, 0, 0, 0.1);
      box-shadow: inset 0 -1px 1px rgba(0, 0, 0, 0.1);
    }
    &:hover:active {
      border: 1px solid rgb(185, 185, 185);
      background-color: #dedede;
      box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.7);
      color: rgba(255, 255, 255, 0.7);
      & > * {
        transform: translate(1px, 1px);
      }
    }
    &--on {
      border: 1px solid rgb(185, 185, 185);
      background-color: #e6ecc8;
      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);
    }
  }
  .ie__function_bar__button--disable {
    filter: grayscale(1);
    opacity: 0.7;
    display: flex;
    height: 100%;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0);
  }
  .ie__function_bar__text {
    margin-right: 4px;
  }
  .ie__function_bar__icon {
    height: 30px;
    width: 30px;
    &--normalize {
      height: 22px;
      width: 22px;
      margin: 0 4px 0 1px;
    }
    &--margin12 {
      height: 22px;
      width: 22px;
      margin: 0 1px 0 2px;
    }
    &--margin-1 {
      margin: 0 -1px;
      height: 30px;
      width: 30px;
    }
  }
  .ie__function_bar__separate {
    height: 90%;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.2);
    margin: 0 2px;
  }
  .ie__function_bar__arrow {
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0 4px;
    &:before {
      content: '';
      display: block;
      border-width: 3px 3px 0;
      border-color: #000 transparent;
      border-style: solid;
    }
  }
  .ie__function_bar__arrow--margin-11 {
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0 1px 0 -1px;
    &:before {
      content: '';
      display: block;
      border-width: 3px 3px 0;
      border-color: #000 transparent;
      border-style: solid;
    }
  }
  .ie__address_bar {
    border-top: 1px solid rgba(255, 255, 255, 0.7);
    height: 22px;
    font-size: 11px;
    display: flex;
    align-items: center;
    padding: 0 2px 2px;
    box-shadow: inset 0 -2px 3px -1px #2d2d2d;
    flex-shrink: 0;
  }
  .ie__address_bar__title {
    line-height: 100%;
    color: rgba(0, 0, 0, 0.5);
    padding: 5px;
  }
  .ie__address_bar__content {
    border: rgba(228, 255, 122, 0.6) 1px solid;
    height: 100%;
    display: flex;
    flex: 1;
    min-width: 0;
    align-items: center;
    background-color: white;
    position: relative;
    margin: 0;
    &__img {
      width: 14px;
      height: 14px;
    }
    &__img:last-child {
      width: 15px;
      height: 15px;
      right: 1px;
      position: absolute;
      cursor: pointer;
    }
    &__img:last-child:hover {
      filter: brightness(1.1);
    }
    &__input {
      position: absolute;
      left: 16px;
      right: 17px;
      top: 0;
      bottom: 0;
      border: 0;
      outline: 0;
      padding: 0 2px;
      margin: 0;
      background: transparent;
      font: inherit;
      font-size: 11px;
      color: #000;
    }
  }
  .ie__address_bar__go {
    display: flex;
    align-items: center;
    padding: 0 10px 0 5px;
    height: 100%;
    position: relative;
    cursor: default;
    &__img {
      height: 95%;
      border: 1px solid rgba(255, 255, 255, 0.2);
      margin-right: 3px;
    }
  }
  .ie__address_bar__year {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0 6px;
    height: 100%;
    color: rgba(0, 0, 0, 0.6);
    select {
      font: inherit;
      font-size: 11px;
      height: 18px;
      border: 1px solid #7a9a00;
      background: #fff;
      color: #000;
    }
  }
  .ie__address_bar__links {
    display: flex;
    align-items: center;
    padding: 0 18px 0 5px;
    height: 100%;
    position: relative;
    cursor: default;
    &__img {
      position: absolute;
      right: 2px;
      top: 3px;
      height: 5px;
      width: 8px;
    }
    &__text {
      color: rgba(0, 0, 0, 0.5);
    }
  }
  .ie__address_bar__separate {
    height: 100%;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    box-shadow: 1px 0 rgba(255, 255, 255, 0.7);
  }
  .ie__content {
    flex: 1;
    min-height: 0;
    display: flex;
    border-left: 1px solid #6f6f6f;
    position: relative;
  }
  .ie__favbar {
    width: 196px;
    flex-shrink: 0;
    background: #f1f1f1;
    border-right: 1px solid #a0a0a0;
    display: flex;
    flex-direction: column;
    font-size: 11px;
    min-height: 0;
  }
  .ie__favbar__head {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 24px;
    padding: 0 6px;
    background: linear-gradient(#fff, #e3e3d8);
    border-bottom: 1px solid #b9b9a5;
    font-weight: 700;
    em {
      font-style: normal;
      font-weight: 400;
      color: #6a8000;
      flex: 1;
    }
  }
  .ie__favbar__x {
    cursor: pointer;
    padding: 0 4px;
    color: #444;
    &:hover {
      color: #000;
    }
  }
  .ie__favbar__hint {
    padding: 6px 8px;
    color: #4b5a20;
    line-height: 1.4;
    background: #f7fbe6;
    border-bottom: 1px solid #dbe9a3;
  }
  .ie__favbar__list {
    flex: 1;
    overflow-y: auto;
    padding: 4px 0;
  }
  .ie__favbar__group {
    padding: 6px 8px 2px;
    color: #6a8000;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .ie__fav {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 8px;
    cursor: default;
    img {
      width: 16px;
      height: 16px;
    }
    span {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    em {
      font-style: normal;
      color: #7a9a00;
      font-family: 'Lucida Console', monospace;
      font-size: 10px;
    }
    &:hover {
      background: #e6ecc8;
      text-decoration: underline;
    }
    &--on {
      background: #dff28e;
      font-weight: 700;
    }
    &--hist span {
      color: #444;
    }
    &--home {
      margin-top: 6px;
      border-top: 1px solid #dbe9a3;
      padding-top: 6px;
    }
  }
  .ie__main {
    flex: 1;
    min-width: 0;
    overflow: auto;
    padding-left: 1px;
    background-color: #f1f1f1;
    position: relative;
  }
  .ie__main--web {
    overflow: hidden;
    background: #fff;
  }
  .ie__content__inner {
    position: relative;
    min-height: 800px;
    min-width: 800px;
    width: 100%;
    height: 100%;
  }
  .ie__frame {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
    background: #fff;
    opacity: 0;
    transition: opacity 0.3s;
  }
  .ie__frame--on {
    opacity: 1;
  }
  .ie__connecting {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 12px;
    color: #333;
    text-align: center;
    padding: 20px;
    background: #fff;
    z-index: 1;
    img {
      width: 32px;
      height: 32px;
      animation: ie-spin 3s linear infinite;
    }
    small {
      color: #7a7a7a;
      max-width: 360px;
      line-height: 1.4;
    }
  }
  @keyframes ie-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  .ie__footer {
    height: 20px;
    border-top: 1px solid transparent;
    box-shadow: inset 0 1px 3px rgba(50, 50, 50, 0.8);
    background-color: rgb(236, 233, 216);
    display: flex;
    align-items: center;
    padding-top: 2px;
    flex-shrink: 0;
  }
  .ie__footer__status {
    flex: 1;
    min-width: 0;
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 2px;
    &__text {
      font-size: 11px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &__img {
      height: 14px;
      width: 14px;
      margin-right: 3px;
    }
  }
  .ie__footer__block {
    height: 85%;
    width: 22px;
    border-left: 1px solid rgba(0, 0, 0, 0.15);
    box-shadow: inset 1px 0 rgba(255, 255, 255, 0.7);
  }
  .ie__footer__right {
    display: flex;
    align-items: center;
    width: 150px;
    height: 80%;
    border-left: 1px solid rgba(0, 0, 0, 0.11);
    box-shadow: inset 1px 0 rgba(255, 255, 255, 0.7);
    padding-left: 5px;
    position: relative;
    &__text {
      font-size: 11px;
    }
    &__img {
      height: 14px;
      width: 14px;
      margin-right: 3px;
    }
    &__dots {
      position: absolute;
      right: 11px;
      bottom: -1px;
      width: 2px;
      height: 2px;
      box-shadow: 2px 0px rgba(0, 0, 0, 0.25), 5.5px 0px rgba(0, 0, 0, 0.25),
        9px 0px rgba(0, 0, 0, 0.25), 5.5px -3.5px rgba(0, 0, 0, 0.25),
        9px -3.5px rgba(0, 0, 0, 0.25), 9px -7px rgba(0, 0, 0, 0.25),
        3px 1px rgba(255, 255, 255, 1), 6.5px 1px rgba(255, 255, 255, 1),
        10px 1px rgba(255, 255, 255, 1), 10px -2.5px rgba(255, 255, 255, 1),
        10px -6px rgba(255, 255, 255, 1);
    }
  }
  @media (max-width: 800px) {
    .ie__favbar {
      position: absolute;
      inset: 0;
      width: auto;
      z-index: 2;
    }
    .ie__function_bar__text {
      display: none;
    }
    .ie__address_bar__links {
      display: none;
    }
  }
`;

export default InternetExplorer;
